// extracted by mini-css-extract-plugin
export default {"carousel":"_f06a5f07"};